import { ArrowLeftOutlined, ArrowRightOutlined } from "@mui/icons-material";
import { useState } from "react";
import { styled } from "styled-components";
import { aboutUs } from "../data";
import { useSwipeable } from "react-swipeable";

const AboutUs = () => {
  const [slideIndex, setSlideIndex] = useState(0);

  const handleClick = (direction) => {
    if (direction === "left") {
      setSlideIndex(slideIndex > 0 ? slideIndex - 1 : aboutUs.length - 1);
    } else {
      setSlideIndex(slideIndex < aboutUs.length - 1 ? slideIndex + 1 : 0);
    }
  };

  const handlers = useSwipeable({
    onSwipedLeft: () => handleClick("right"),
    onSwipedRight: () => handleClick("left"),
    preventDefaultTouchmoveEvent: true,
    swipeDuration: Infinity,
  });

  return (
    <Container id="aboutUs" {...handlers}>
      <ArrowLeft onClick={() => handleClick("left")}>
        <ArrowLeftOutlined />
      </ArrowLeft>
      <Wrapper slideIndex={slideIndex}>
        {aboutUs.map((item, index) => (
          <Slide bg={item.bg} key={item.id}>
            <ImgContainer>
              <Image src={`/img/aboutUs/${item.img}`} isFirst={index === 0} />
            </ImgContainer>
            <InfoContainer>
              <Title>{item.title}</Title>
              <Description dangerouslySetInnerHTML={{ __html: item.desc }} />
            </InfoContainer>
          </Slide>
        ))}
      </Wrapper>
      <ArrowRight onClick={() => handleClick("right")}>
        <ArrowRightOutlined />
      </ArrowRight>
    </Container>
  );
};

const Container = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  position: relative;
  overflow: hidden;
  scroll-snap-align: start;
  background: #f5fbfd;
`;

const ArrowLeft = styled.div`
  width: 50px;
  height: 50px;
  background-color: #d3d3d3;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 10px;
  margin: auto;
  cursor: pointer;
  opacity: 0.5;
  z-index: 2;
  transition: all 0.5s ease;
  &:hover {
    background-color: #6a6a6a;
    transform: scale(1.2);
  }
`;

const ArrowRight = styled.div`
  width: 50px;
  height: 50px;
  background-color: #d3d3d3;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: ${(props) => props.direction === "left" && "10px"};
  right: 10px;
  margin: auto;
  cursor: pointer;
  opacity: 0.5;
  z-index: 2;
  transition: all 0.5s ease;
  &:hover {
    background-color: #6a6a6a;
    transform: scale(1.2);
  }
`;

const Wrapper = styled.div`
  padding-top: 10vh;
  display: flex;
  transition: all 1.5s ease;
  transform: translateX(${(props) => props.slideIndex * -100}vw);
  @media (max-width: 768px) {
    padding-top: 0vh;
  }
`;

const Slide = styled.div`
  width: 100vw;
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
    padding-top: 5vh;
  }
`;

const ImgContainer = styled.div`
  height: 100%;
  flex: 0.8;
  align-self: flex-end;
  @media (max-width: 768px) {
    align-self: center;
    position: absolute;
    z-index: 1;
    background-color: black;
  }
`;

const Image = styled.img`
  height: 100%;
  width: 80%;
  object-fit: ${({ isFirst }) => (isFirst ? "contain" : "fill")};
  @media (max-width: 768px) {
    object-fit: fill;
    width: 100%;
    opacity: 0.1;
  }
`;

const InfoContainer = styled.div`
  flex: 1;
  padding: 50px;
  @media (max-width: 768px) {
    width: 80%;
    display: block;
    align-content: center;
    padding: 20px;
    z-index: 2;
    color: white;
  }
`;

const Title = styled.h1`
  font-size: 40px;
  font-family: "Kestrel";
  white-space: pre-wrap;
  @media (max-width: 768px) {
    font-size: 30px;
    text-align: center;
  }
`;

const Description = styled.p`
  margin: 50px 0px;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 1px;
  white-space: pre-wrap;
  @media (max-width: 768px) {
    font-size: 14px;
    letter-spacing: 0.2px;
  }
`;

export default AboutUs;
